import { useState, useEffect, useRef } from 'react'
import RewriteResultItem from "./RewriteResultItem";

function RewriteResultsList({ 
    results, 
    editingRewriteIndex, 
    editedRewriteContent, 
    isSaving,
    onRewriteEditToggle, 
    onRewriteContentChange, 
    onRewriteSave, 
    onCopy,
    openVoiceSettingsModal,
    openVoiceModal,
    hasApiKey,
    showAvatarGenerateModel, currentPlayingId, isPlaying, onPlayVoice
}) {

    try {
        return (
            <div className="mt-4">
                <h4 className="text-sm font-medium text-gray-700 mb-1">重寫內容：</h4>
                <div className="space-y-4">
                    {results.map((result, index) => (
                        <RewriteResultItem
                            key={index}
                            result={result}
                            index={index}
                            isEditing={editingRewriteIndex === index}
                            editedContent={editedRewriteContent}
                            isSaving={isSaving}
                            onEditToggle={(e) => onRewriteEditToggle(e, index, result.id)}
                            onContentChange={onRewriteContentChange}
                            onSave={(e) => onRewriteSave(e, index, result.id)}
                            onCopy={onCopy}
                            openVoiceSettingsModal={openVoiceSettingsModal}
                            openVoiceModal={(e) => openVoiceModal(e, index)}
                            hasApiKey={hasApiKey}
                            showAvatarGenerateModel={showAvatarGenerateModel}
                            currentPlayingId={currentPlayingId}
                            isPlaying={isPlaying}
                            onPlayVoice={onPlayVoice}
                        />
                    ))}
                </div>
            </div>
        );
    } catch (error) {
        console.error('RewriteResultsList component error:', error);
        reportError(error);
        return null;
    }
}

export default RewriteResultsList;